export const accountPages = ['routes/$basename.account'];

export const authPages = [
  'routes/$basename.login._index',
  'routes/$basename.login.email',
  'routes/$basename.forgot-password',
  'routes/$basename.reset-password',
  'routes/$basename.signup',
];

export const customRowPages = [
  'routes/$basename.rows.$customRowId.$slug',
  'routes/$basename.store.$storeId.rows.$customRowId.$slug',
];

export const featuredPages = [
  'routes/$basename.featured._index',
  'routes/$basename.store.$storeId.featured._index',
];

export const categoryPages = [
  'routes/$basename.edible._index',
  'routes/$basename.extract._index',
  'routes/$basename.flower._index',
  'routes/$basename.gear._index',
  'routes/$basename.grow._index',
  'routes/$basename.merch._index',
  'routes/$basename.pre-roll._index',
  'routes/$basename.tincture._index',
  'routes/$basename.topical._index',
  'routes/$basename.vape._index',
  'routes/$basename.shop-all._index',

  'routes/$basename.store.$storeId.edible._index',
  'routes/$basename.store.$storeId.extract._index',
  'routes/$basename.store.$storeId.flower._index',
  'routes/$basename.store.$storeId.gear._index',
  'routes/$basename.store.$storeId.grow._index',
  'routes/$basename.store.$storeId.merch._index',
  'routes/$basename.store.$storeId.pre-roll._index',
  'routes/$basename.store.$storeId.tincture._index',
  'routes/$basename.store.$storeId.topical._index',
  'routes/$basename.store.$storeId.vape._index',
  'routes/$basename.store.$storeId.shop-all._index',
];

export const plpPages = [
  ...featuredPages,
  ...categoryPages,
  ...customRowPages,

  'routes/$basename.search',

  'routes/$basename.deals._index',
  'routes/$basename.deals.$dealId.$slug',
  'routes/$basename.jane-gold._index',
  'routes/$basename.jane-gold.$specialId.$slug',

  'routes/$basename.store.$storeId.deals._index',
  'routes/$basename.store.$storeId.deals.$dealId.$slug',
  'routes/$basename.store.$storeId.jane-gold._index',
  'routes/$basename.store.$storeId.jane-gold.$specialId.$slug',
];

export const pdpPages = ['routes/$basename.products.$productId.$slug'];
